import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../App';
import NotificationBell from './NotificationBell';

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [showMenu, setShowMenu] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    navigate(`/search?q=${encodeURIComponent(search.trim())}`);
    setSearch('');
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        NINTY
      </div>
      <div className="navbar-links">
        <button className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`} onClick={() => navigate('/')}>Browse</button>
        <button className={`navbar-link ${location.pathname === '/categories' ? 'active' : ''}`} onClick={() => navigate('/categories')}>Categories</button>
        {user && <button className={`navbar-link ${location.pathname === '/following' ? 'active' : ''}`} onClick={() => navigate('/following')}>Following</button>}
        {user && <button className={`navbar-link ${location.pathname === '/dashboard' ? 'active' : ''}`} onClick={() => navigate('/dashboard')}>Dashboard</button>}
      </div>

      {/* Search bar — hidden on mobile via CSS class */}
      <form onSubmit={handleSearch} className="navbar-search">
        <input
          className="input"
          style={{ marginBottom: 0, height: '34px', fontSize: '0.875rem', background: '#0e0e10' }}
          placeholder="Search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </form>

      <div className="navbar-actions">
        {user ? (
          <>
            <NotificationBell />
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setShowMenu(!showMenu)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px',
                  borderRadius: '6px', color: '#adadb8', fontSize: '0.85rem',
                }}
                onBlur={() => setTimeout(() => setShowMenu(false), 150)}
              >
                <span className="navbar-avatar">
                  {user.avatar_url
                    ? <img src={user.avatar_url} alt="" style={{ width: 24, height: 24, borderRadius: '2px', objectFit: 'cover' }} />
                    : <span style={{ width: 24, height: 24, borderRadius: '2px', background: '#2a2a2e', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', boxShadow: '1px 1px 0 rgba(0,0,0,0.3)' }}>
                        {(user.display_name || user.username).charAt(0).toUpperCase()}
                      </span>
                  }
                </span>
                <span className="navbar-username">@{user.username}</span>
              </button>
              {showMenu && (
                <div className="navbar-dropdown">
                  <button onClick={() => { navigate(`/${user.username}`); setShowMenu(false); }}>My Channel</button>
                  <button onClick={() => { navigate('/settings'); setShowMenu(false); }}>Settings</button>
                  <button onClick={() => { navigate('/following'); setShowMenu(false); }}>Following</button>
                  <button onClick={() => { navigate('/dashboard'); setShowMenu(false); }}>Dashboard</button>
                  <button onClick={() => { navigate('/guidelines'); setShowMenu(false); }}>Guidelines</button>
                  <button onClick={() => { navigate('/copyright'); setShowMenu(false); }}>Copyright</button>
                  {user.is_admin && <button onClick={() => { navigate('/admin'); setShowMenu(false); }}>Admin Panel</button>}
                  <div className="navbar-dropdown-divider" />
                  <button onClick={() => { logout(); setShowMenu(false); }}>Sign Out</button>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <button className="btn btn-outline" onClick={() => navigate('/login')}>Log In</button>
            <button className="btn btn-primary" onClick={() => navigate('/signup')}>Sign Up</button>
          </>
        )}
      </div>
    </nav>
  );
}
